import { Expose } from "@nts/std/serialization";
import { OCCAuditDeactivableModel } from "../occ-audit-deactivable-model";
import { NumberDecorator } from "../decorators/number.decorator";
import { SingleAggregateAuditDeactivableModelInterface, SingleAggregateIdentityInterface } from "@nts/std/interfaces";


export class SingleAggregateAuditDeactivableModel<TIdentity extends SingleAggregateIdentityInterface>
  extends OCCAuditDeactivableModel<TIdentity> implements SingleAggregateAuditDeactivableModelInterface<TIdentity> {

  static override PROPERTY_LIST: string[] = [
    ...OCCAuditDeactivableModel.PROPERTY_LIST,
    'fixedIdentity'
  ];

  private _fixedIdentity: number;

  @Expose()
  @NumberDecorator({ displayNameKey: 'SingleAggregateModel_FixedIdentity' })
  get fixedIdentity(): number {
    return this.getValueForIdentityValue<number>(() => this._fixedIdentity, 'fixedIdentity');
  }
  set fixedIdentity(value: number) {
    this.setValueForIdentityValue<number>(() => { this._fixedIdentity = value; }, value, 'fixedIdentity');
  }
}
